var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RandomModulatorBoxAdapter_instances, _RandomModulatorBoxAdapter_localIndex, _RandomModulatorBoxAdapter_quantize, _RandomModulatorBoxAdapter_wrapParameters;
import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { LfoModulatorBoxAdapter } from "./LfoModulatorBoxAdapter";
import { ModulatorBoxAdapter } from "./ModulatorBoxAdapter";
// WASM CONTRACT: `draw` and `quantize` mirror the engine's `modulation::hash_bipolar` / `quantize`.
export class RandomModulatorBoxAdapter extends ModulatorBoxAdapter {
    constructor(context, box) {
        super(context, box);
        _RandomModulatorBoxAdapter_instances.add(this);
        this.namedParameter = __classPrivateFieldGet(this, _RandomModulatorBoxAdapter_instances, "m", _RandomModulatorBoxAdapter_wrapParameters).call(this, box);
        this.registerParameterTracks();
    }
    get loop() { return this.box.loop.getValue(); }
    draw(index) {
        const seed = this.box.seed.getValue();
        const local = __classPrivateFieldGet(this, _RandomModulatorBoxAdapter_instances, "m", _RandomModulatorBoxAdapter_localIndex).call(this, index);
        let hash = Math.imul(seed, 0x9E3779B1) ^ Math.imul(local, 0x85EBCA77);
        hash = Math.imul(hash ^ (hash >>> 15), 0x2545F491);
        hash ^= hash >>> 13;
        return __classPrivateFieldGet(this, _RandomModulatorBoxAdapter_instances, "m", _RandomModulatorBoxAdapter_quantize).call(this, (hash >>> 0) / 4294967295.0 * 2.0 - 1.0);
    }
    valueAt(step) {
        const index = Math.floor(step);
        const current = this.draw(index);
        const smooth = this.box.smooth.getValue();
        if (smooth <= 0.0) {
            return current;
        }
        const previous = this.draw(index - 1);
        const ramp = Math.min(1.0, (step - index) / smooth);
        return previous + (current - previous) * ramp * ramp * (3.0 - 2.0 * ramp);
    }
    reseed() { this.box.seed.setValue(Math.floor(Math.random() * RandomModulatorBoxAdapter.MaxSeed)); }
}
_RandomModulatorBoxAdapter_instances = new WeakSet(), _RandomModulatorBoxAdapter_localIndex = function _RandomModulatorBoxAdapter_localIndex(index) {
    const length = this.loop;
    return length > 0 ? ((index % length) + length) % length : index | 0;
}, _RandomModulatorBoxAdapter_quantize = function _RandomModulatorBoxAdapter_quantize(value) {
    const levels = this.box.levels.getValue();
    if (levels < 2) {
        return value;
    }
    const steps = levels - 1;
    return Math.min(steps, Math.max(0, Math.floor((value + 1.0) * 0.5 * steps + 0.5))) / steps * 2.0 - 1.0;
}, _RandomModulatorBoxAdapter_wrapParameters = function _RandomModulatorBoxAdapter_wrapParameters(box) {
    return {
        rateSync: this.parametric.createParameter(box.rateSync, ValueMapping.linearInteger(0, LfoModulatorBoxAdapter.RateStrings.length - 1), StringMapping.indices("", LfoModulatorBoxAdapter.RateStrings), "Sync"),
        rateAbsolute: this.parametric.createParameter(box.rateAbsolute, ValueMapping.powerByCenter(LfoModulatorBoxAdapter.CenterAbsoluteRate, 0.0, LfoModulatorBoxAdapter.MaxAbsoluteRate), StringMapping.numeric({ unit: "Hz", fractionDigits: 2 }), "Free"),
        phase: this.parametric.createParameter(box.phase, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "Phase"),
        smooth: this.parametric.createParameter(box.smooth, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "Smooth")
    };
};
RandomModulatorBoxAdapter.MaxLoop = 64;
RandomModulatorBoxAdapter.MaxLevels = 32;
RandomModulatorBoxAdapter.MaxSeed = 999999;
